import { FC, useContext } from 'react'
import { useQuery } from 'react-query'
import {
  createResponseContextSemPaginacao,
  initialQueryResponseSemPaginacao,
  QUERIES,
  showError,
  WithChildren,
} from '../../../../../../_metronic/helpers'
import { useParametrosIndicadores } from './QueryRequestProvider'
import { IndicadoresQualidade, ParametrosIndicadores } from './_models'
import { getIndicadoresQualidade } from './_requests'

/**
 * Provider irmão do operacional, com a mesma forma de contexto e chave de cache
 * própria (`QUERIES.INDICADORES_QUALIDADE`). São duas famílias com payloads
 * diferentes: reaproveitar o contexto do operacional traria a resposta errada.
 */
const QueryResponseQualidadeContext = createResponseContextSemPaginacao<IndicadoresQualidade>(
  initialQueryResponseSemPaginacao
)

/** Montado só dentro da aba Qualidade: a request existe apenas enquanto a aba está na tela. */
export const QueryResponseQualidadeProvider: FC<WithChildren> = ({ children }) => {
  const { parametros, query } = useParametrosIndicadores()

  const { isFetching, refetch, data } = useQuery(
    [QUERIES.INDICADORES_QUALIDADE, query],
    () => getIndicadoresQualidade(parametros as ParametrosIndicadores),
    {
      enabled: Boolean(parametros),
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      onError: showError,
    }
  )

  return (
    <QueryResponseQualidadeContext.Provider
      value={{
        isLoading: isFetching,
        refetch,
        singleResponse: data,
        query,
      }}
    >
      {children}
    </QueryResponseQualidadeContext.Provider>
  )
}

export const useQueryResponseQualidade = () => useContext(QueryResponseQualidadeContext)
